export default function auth(state = {}) {
  return state;
}



// WEBPACK FOOTER //
// ./app/states/reducers/auth.js